const config = {
    baseURL: '/bakend',
    serverURL: 'http://36.137.213.156:7200/'
};
export default config;